module.exports = __webpack_public_path__ + "img/wo.15ae9f54.png";